import { AxiosResponse } from 'axios'
import { http } from '../realisations/Http.realisation'
import { TransitGetTTNSResponseT } from '../types/transit.types'

export class TransitRepository {
    getTTNS(number: string): Promise<AxiosResponse<TransitGetTTNSResponseT>> {
        return http.get(`/transit/api/v1/ttn/${number}`)
    }

    setDeliveryDate(tripNumber: string, cityName: string): Promise<AxiosResponse<void>> {
        return http.post('/transit/api/v1/ttn/set-delivery-date', { tripNumber, cityName })
    }
}
